import { Skeleton } from "@/components/ui/skeleton";

interface SuggestionCardSkeletonProps {
  showAvatar?: boolean;
}

export const SuggestionCardSkeleton = ({ showAvatar = false }: SuggestionCardSkeletonProps) => {
  return (
    <div className="p-4 rounded-lg border border-gray-100">
      {showAvatar && (
        <div className="flex items-center gap-3 mb-3">
          <Skeleton className="w-10 h-10 rounded-full" />
          <Skeleton className="h-5 w-32" />
        </div>
      )}
      <Skeleton className="h-5 w-3/4 mb-2" />
      <Skeleton className="h-4 w-full mb-1" />
      <Skeleton className="h-4 w-5/6 mb-3" />
      <div className="flex items-center gap-2">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-24" />
      </div>
    </div>
  );
};
